module.exports = __webpack_public_path__ + "public/pdf/policy.pdf";